import { orderBusiness } from "api/bussiness/order/order-bussiness";
import { mapToDistinctOptionItems } from "commons/ultilities/option-item/option-item-ultil";
import type { AutoCompleteProvider } from "./factory";

const normalizeOrderCustomerId = (
  customerId?: string | number | null,
): string | undefined => {
  if (customerId == null || typeof customerId === 'number') {
    return undefined;
  }
  const normalizedValue = String(customerId).trim();
  return normalizedValue === "" ? undefined : normalizedValue;
};

export const orderAutoCompleteProvider: AutoCompleteProvider = {
  searchOptionItemsAsync: async (keyword, context) => {
    return orderBusiness.searchOrdersAsOptionItems(
      keyword,
      normalizeOrderCustomerId(context?.customerId),
    );
  },
  searchOptionItemsPagedAsync: async (keyword, request, context) => {
    const customerId = normalizeOrderCustomerId(context?.customerId);

    const orders = await orderBusiness.getLists({
      filter: keyword,
      maxResultCount: request.pageSize,
      skipCount: request.pageIndex * request.pageSize,
      sorting: "",
      customerId,
    });

    return {
      items: mapToDistinctOptionItems(
        orders.items,
        (item) => item.id,
        (item) => item.poNumber,
      ),
      totalCount: orders.totalCount,
    };
  },
  resolveSelectedOptionAsync: async (value) => {
    const normalizedId = String(value ?? "").trim();
    if (!normalizedId) {
      return null;
    }

    try {
      const order = await orderBusiness.getById(normalizedId);
      if (!order?.id) {
        return null;
      }

      return {
        value: order.id,
        label: order.poNumber || normalizedId,
      };
    } catch {
      return null;
    }
  },
};
